module.exports = __webpack_public_path__ + "img/baiwang.3e8097f1.png";